module.exports = __webpack_public_path__ + "media/images/icons/facebook-5a6f951cbeeab111fe80e3e1e95b763b.svg";